import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import BaseLayout from 'base/layouts/Layout';

const LAYOUT_PADDING = {
  pl: 0,
  pr: 0,
  pb: 3
};

const OrderSettingsLayout = ({ children, heroImage, isFetching }) => {
  return (
    <BaseLayout
      heroSrc={heroImage.url}
      heroAlt={heroImage.alt_text}
      isFetching={isFetching}
      hideNav
      hideHeroOnMobile
      hideBrandFooterOnMobile
      hideMobileStickyCtaFooter
      isModal
      layoutPadding={LAYOUT_PADDING}
    >
      {children}
    </BaseLayout>
  );
};

OrderSettingsLayout.propTypes = {
  children: PropTypes.object,
  heroImage: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  isFetching: PropTypes.bool
};

const mapStateToProps = state => ({
  isFetching: state.menu.isFetching,
  heroImage: get(state.menu, 'images[0]', {})
});

export default connect(mapStateToProps)(OrderSettingsLayout);
